﻿import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

export function Money(
    {
        currency = "GBP",
        children
    }
) {

    return (<Fragment>{formatStringToMoney(children)}</Fragment>);

    function formatStringToMoney(value) {
        if (value == null || isNaN(value)) {
            return "-";
        }
        else {
            return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }).format(value);
        }
    }
}

Money.propTypes = {
    currency: PropTypes.string
};